import React from 'react';
import PropTypes, { string } from 'prop-types';

import getIcon from '../../../icons';
import { id_chevron_icon } from '../constants';

/**
 * FilterButton component that renders a button with a chevron icon.
 *
 * @component
 * @param {Object} props - The component props
 * @param {boolean} [props.disabled] - Whether the button is disabled
 * @param {string} props.testId - Test ID for testing purposes
 * @param {Object} props.className - Object containing CSS class names
 * @param {string} props.className.container - CSS class for the container div
 * @param {string} props.className.actionBtn - CSS class for the action button
 * @param {string} [props.ariaLabel] - Accessible label for the button
 * @returns {React.ReactElement} The rendered FilterButton component
 */
const FilterButton = ({ disabled, testId, className, ariaLabel }) => (
  <div className={className.container}>
    <button
      data-testid={testId}
      type="submit"
      className={className.actionBtn}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {getIcon({ iconId: id_chevron_icon })}
    </button>
  </div>
);

FilterButton.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.shape({ actionBtn: string, container: string }),
  disabled: PropTypes.bool,
  testId: PropTypes.string.isRequired,
};

export default FilterButton;
